export default {
  injuryImpact: {
    title: "Lesiones",
    labels: {
      withoutPlayer: "Sin {{player}}",
    },
    empty: {
      title: "No hay lesiones disponibles",
    },
  },
};
